//@ts-ignore
//@ts-nocheck
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { API } from "aws-amplify";

import { modalSteps } from "../../Store/simulate/actions";
import {
  cardProducts,
  getTitleCase,
} from "../../Utils/simulaciones/simulaciones";
import useBeforeFirstRender from "../../customHook/useBeforFirstRender";

import BreadCrumbs from "../BreadCrumbs";

import NavResponsive from "../../Components/FormElements/NavResponsive";
import ModalSteps from "./FormElements/ModalSteps";
import Button from "../../Components/FormElements/Button";
import FormTitle from "../../Components/FormElements/FormTitle";
import NavCase from "../../Components/FormElements/NavCase";
import CardAprobar from "../../Components/FormElements/CardAprobar";
import Footer from "../../Components/Footer";
import { transformInsuredData, transformLegalData, transformLegalRepresentativeData, transformNaturalData} from '../../Utils/simulaciones/simulaciones'
import IconBack from "../../Resources/svg/Icons/IconBack";
import IconInformation from "../../Resources/svg/Icons/IconInformation";
import AlertMessage from "../../Components/alertMessage";
import alert from "../../Resources/img/icon-alert-yellow.png";
import { VALOR_OPORTUNIDAD } from "../../Utils/constants";

export const VerifySimulation = () => {
  const [loadingClick, setLoadingClick] = useState<any>(false);
  const dispatch = useDispatch();
  const { handleSubmit } = useForm();
  const [loading, setLoading] = useState<any>(false);
  const [apiErrorMessage, setApiErrorMessage] = useState<string>("");

  const healthStatementData = useSelector(
    (state: any) => state.simulate.policy.healthStatement
  );
  const answersData = useSelector(
    (state: any) => state.simulate.policy.answers
  );
  const workData = useSelector((state: any) => state.simulate.policy.workData);

  const history = useHistory();
  const beneficiary = useSelector(
    (state: any) => state.simulate.policy.beneficiary
  );
  const data = useSelector((state: any) => state.simulate.policy.client);
  const { apiCliente } = useSelector((state: any) => state.simulate.policy);
  const client = data.datosCliente;
  const asegurados = data.asegurado;

  const clientData = client ? client.datosParticulares : null;
 
  const epaData = {
    ...clientData,
    id: "1",
    typeDoc: asegurados.typeDoc.valor || "",
    document: asegurados.document || "",
    names: asegurados.names || "",
    firstName: asegurados.firstName || "",
    lastName: asegurados.lastName || "",
    birthdate: asegurados.birthdate || "",
    sexo: asegurados.sexo || "",
    phone: asegurados.mobile || "",
  };
  const validateClientData =
    clientData.firstName === null ? epaData : clientData;

  let tramaCoti: any[] = [];
  let cardCoti: any[] = [];
  let valErrorServiceUpdateSAS: any = false;

  useBeforeFirstRender(client);

  const onSubmit = async () => {
    setApiErrorMessage("");
    setLoadingClick(true);
    setLoading(true);

    await guardarCotizacion();
    window.digitalData.push({
      event: "trackQuateGlobalInvestment",
    });
  };

  const guardarCotizacion = async () => {
    const healthStatement: any = {};
    healthStatementData.map((item: any) => {
      healthStatement[item.sk] = item.value;
    });


    let request: any = {
      body: {
        idSimulacion: data.idSimulacion,
        datosCliente: {
          datosParticulares: validateClientData,
          beneficiarios: {
            legales: beneficiary.length > 0 ? false : true,
            personalizados: beneficiary,
          },
          datosLaborales: workData,
          answers: {
            ...healthStatement,
            ...answersData,
          },
        },
        apiCliente,
        estado: "pendiente",
        acumuladoOrigenesFondo: data.acumuladoOrigenesFondo,
        sustento: data.sustento,
        errorServiceUpdateSAS: valErrorServiceUpdateSAS,
      },
    };

    if(data.producto.codigo === 'RG' || data.producto.codigo === 'IG' || data.producto.codigo === 'UC'){
      if(data.datosJuridico && data.datosAsegurado){
        if(data.contratante.typeContractor === 'PERSON'){
            request = {
              body: {
                ...request.body,
                datosAsegurado: transformInsuredData(data.datosAsegurado, data.asegurado),
                datosNatural: transformNaturalData(data.datosJuridico, data.contratante),
                haveContractor: true,
                typeContractor: data.contratante.typeContractor
              }
            }
        } else if (data.contratante.typeContractor === 'ENTITY'){
          request = {
            body: {
              ...request.body,
              datosAsegurado: transformInsuredData(data.datosAsegurado, data.asegurado),
              datosJuridico: transformLegalData(data.datosJuridico, data.contratante),
              datosRepLegal: transformLegalRepresentativeData(data.datosJuridico, data.contratante),
              datosNatural: transformLegalRepresentativeData(data.datosJuridico, data.contratante),
              haveContractor: true,
              typeContractor: data.contratante.typeContractor,
            }
          }
        } 
      }else{
        request = {
          body: {
            ...request.body,
            datosAsegurado: transformInsuredData(data.datosAsegurado, data.asegurado),
            haveContractor: false
          }
        }
      }
    }
  try {
    const response = await API.post("api-rentas", "/save-quote", request);

    if (response.status === 404) {
      history.push("/cotizaciones/error-simulacion", {
        timeOut: false,
      });
    } else if (response.status) {
      setTimeout(() => {
        setLoadingClick(false);
        history.push({
          pathname: "/cotizaciones/solicitud-cotizacion",
          state: response.data,
        });
      }, 500);
    } else if (response.message && response.message.toUpperCase().includes(VALOR_OPORTUNIDAD)) {
      setApiErrorMessage(response.message);
      setLoadingClick(false);
      setLoading(false);
    } else {
      setLoadingClick(false);
      history.push("/cotizaciones/error-simulacion", {
        timeOut: false,
      });
    }
  } catch (error: any) {
    if(error.response){
      if (error.response.status == 504) {
        setTimeout(() => {
          setLoadingClick(false);
          history.push({
            pathname: "/cotizaciones/solicitud-cotizacion",
            state: error.response.data || {},
          });
        }, 500);
      } else {
        setLoadingClick(false);
        history.push("/cotizaciones/error-simulacion", {
          timeOut: false,
        });
      }
    } else {
      setTimeout(() => {
        setLoadingClick(false);
        history.push({
          pathname: "/cotizaciones/solicitud-cotizacion",
          state: {},
        });
      }, 500);
    }
  }}
  if (client) {
    const nameCli = validateClientData.names;
    const ApeCli = validateClientData.firstName.concat(
      " ",
      validateClientData.lastName
    );

    const firstName = nameCli ? getTitleCase(nameCli) : "";

    const lastName = ApeCli ? getTitleCase(ApeCli) : "";

    const urbanization = clientData.address.urbanization
      ? `, Urb. ${clientData.address.urbanization}`
      : clientData.address.urbanization;

    const sexCli = validateClientData.sexo === "F" ? "Femenino" : "Masculino";
    const dirCli = validateClientData.address.type.concat(
      ". ",
      validateClientData.address.name,
      ", ",
      validateClientData.address.number,
      " ",
      urbanization,
      ", ",
      validateClientData.address.nameUbigeo.district
    );
    let herederos: any = [];

    if (beneficiary.length > 0 && beneficiary[0].nombres !== "") {
      beneficiary.map((heredero: any) =>
        herederos.push({
          nombre: heredero.nombres,
          apellido: heredero.apePaterno.concat(" ", heredero.apeMaterno),
          tipoDoc: heredero.tipoDoc || heredero.typeDoc.valor,
          dni: heredero.documento,
          fecNacimiento: heredero.fecNacimiento,
          sexo: heredero.sexo === "F" ? "Femenino" : 
                heredero.sexo === "M" ? "Masculino" :
                "",
          numCelular: heredero.numCelular,
          correoElectronico: heredero.correoElectronico,
          relacion: heredero.relacion,
          beneficio: heredero.porcentaje,
        })
      );
    }
    
    cardCoti = cardProducts(
      data,
      tramaCoti,
      firstName,
      lastName,
      validateClientData,
      sexCli,
      dirCli,
      herederos
    );
  }
  const handleOpenModal = () => {
    dispatch(modalSteps(true));
  };

  useEffect(() => {
    window.digitalData.push({
      virtual: {
        name: "aiv:inversion-global:cotizar:verificacion-datos",
      },
      event: "trackVirtual",
    });
  }, []);

  return (
    <>
      <div className="wrap">
        <NavResponsive position={7} title="Verificación de datos" />
        <div className="content-box d-flex">
          <div className="nav-case">
            <BreadCrumbs
              rutas={[{ link: "Simulaciones" }, { link: "Cotización" }]}
            />
            <div className="nav-case__routing">
              <IconBack className="nav-case__back" onClick={handleOpenModal} />
              <div className="nav-case__title">Verificación de datos</div>
              <NavCase />
            </div>
          </div>
          <div className="form-register">
            <FormTitle
              title="Verifica los datos del contratante"
              parrafo="El contratante es la persona que es titular de la póliza y asegurado a la vez."
            />

            <form onSubmit={handleSubmit(onSubmit)}>
              {cardCoti.map((coti, i) => (
                <CardAprobar key={i} loading={loading} data={coti} showFile={false} />
              ))}
              {/* {data.datosCliente.tipoDoc.nombre === "DNI" && (
                <div className="form-register__information">
                  <IconInformation />
                  <div>
                    Al hacer clic en el botón <span>“Finalizar”</span> se
                    enviará automáticamente la cotización a tu cliente.
                  </div>
                </div>
              )} */}
              {apiErrorMessage && (
                <div className="form-register__error-message" style={{ marginTop: "20px" }}>
                  <AlertMessage
                    background="#FFEFD8"
                    icono={alert}
                    mensaje={apiErrorMessage}
                  />
                </div>
              )}
              <div className="form-register__border"></div>
              <div className="form-register__buttom form-step">
                <Button
                  type="submit"
                  className={loadingClick ? "is-loading" : ""}
                >
                  Finalizar
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ModalSteps />
      <Footer />
    </>
  );
};
